import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { IdiomaCard } from "./IdiomaCard";
import { paginacion } from "../../utils/paginacion/paginacion";

const IDIOMAS_POR_PAGINA = 15;

export const IdiomaList = ({ idiomas = [], onRefresh }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda] = useState("");

  const idiomasFiltrados = idiomas.filter((idioma) => {
    const texto = busqueda.toLowerCase();
    return (
      idioma?.nombre?.toLowerCase().includes(texto) ||
      idioma?.sigla?.toLowerCase().includes(texto)
    );
  });

  const {
    objetosEnPagina: idiomasEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, idiomasFiltrados, IDIOMAS_POR_PAGINA);

  const columnas = ["#", "Código", "Nombre", "Opciones"];

  return (
    <section className="px-4 pb-10 max-w-6xl mx-auto">
      <div className="flex justify-between items-center my-4">
        <input
          type="text"
          placeholder="Buscar por código o nombre..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setPaginaActual(1); // Reiniciar la paginación al buscar
          }}
          className="border border-gray-300 rounded px-4 py-2 w-full max-w-md"
        />
      </div>

      <DataTable
        columnas={columnas}
        paginas={paginas}
        paginaInicial={paginaInicial}
        paginaFinal={paginaFinal}
        paginaActual={paginaActual}
        setPaginaActual={setPaginaActual}
      >
        {idiomasEnPagina?.map((idioma, index) => (
          <IdiomaCard
            key={idioma.idIdioma || index}
            idioma={idioma}
            index={(paginaActual - 1) * IDIOMAS_POR_PAGINA + index + 1}
            onDelete={onRefresh}
          />
        ))}
      </DataTable>
    </section>
  );
};
